import {
  ADD_TEXTBAUSTEIN,
  DELETE_TEXTBAUSTEIN,
  FETCH_TEXTBAUSTEINE,
  UPDATE_TEXTBAUSTEIN,
} from "../actions/types";

function sortByTextbausteinPunkte(textbausteine) {
  const arr = "zyxwvutsrqponmlkjihgfedcba";
  return textbausteine
    .map((tb) => {
      const sort = `${tb.punkte
        .split(",")
        .map((p) => parseInt(p.trim()))
        .map((i) => arr[i])
        .join()}_${tb.number}`;
      return { ...tb, sort };
    })
    .sort((a, b) => (a.sort > b.sort ? 1 : -1));
}

export default function rootReducer(state = [], action) {
  switch (action.type) {
    case FETCH_TEXTBAUSTEINE:
      if (!action.textbausteine) return state;
      return sortByTextbausteinPunkte([...action.textbausteine]);
    case ADD_TEXTBAUSTEIN:
      if (!action.textbaustein) return state;
      return sortByTextbausteinPunkte([...state, action.textbaustein]);
    case UPDATE_TEXTBAUSTEIN:
      if (!action.textbaustein) return state;
      return [
        ...state.filter((tb) => tb.id !== action.textbaustein.id),
        action.textbaustein,
      ];
    case DELETE_TEXTBAUSTEIN:
      // console.log({ action });
      if (!action.deleted) return state;
      return sortByTextbausteinPunkte([
        ...state.filter((tb) => tb.id !== action.deleted.id),
      ]);
    default:
      return state;
  }
}
